import { useEffect, useRef, useState } from "react";

/**
 * A solid downward-pointing triangle, not lucide's ChevronDown (an outlined
 * angle-bracket shape, "⌄") — the two read as different affordances at this
 * size, and this dropdown wants the classic filled-triangle one.
 */
function TriangleDownIcon({ className }) {
  return (
    <svg viewBox="0 0 10 6" className={className} aria-hidden="true">
      <polygon points="0,0 10,0 5,6" fill="currentColor" />
    </svg>
  );
}

function CustomSelectBox({
  label,
  value,
  options,
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="relative flex items-center bg-white rounded-2xl py-1.5 px-5" ref={ref}>
      <label className="block text-gray-800 text-xs w-[120px] uppercase">{label}</label>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className="w-full bg-white text-black ps- py-2 rounded outline-none flex items-center justify-between"
      >
        <span className="truncate">{value}</span>
        <TriangleDownIcon className="h-[6px] w-[10px] flex-none opacity-70" />
      </button>

      {open && (
        <ul
          role="listbox"
          className="absolute left-0 top-full mt-2 w-full rounded-2xl bg-white shadow-lg ring-1 ring-black/20 overflow-hidden z-[1000]"
        >
          {options.map((opt, i) => (
            <li
              key={opt}
              role="option"
              aria-selected={opt === value}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className={`px-4 py-3 cursor-pointer text-black hover:bg-gray-200 ${
                opt === value ? "bg-gray-100" : ""
              } ${i < options.length - 1 ? "border-b border-gray-300/40" : ""}`}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomSelectBox;
